import { type SessionDetail, type SessionRow, api } from '../lib/api.js';
import { el, mount } from '../lib/dom.js';
import { formatDateTime, formatDateTimeFull } from '../lib/format.js';
import { navigate } from '../lib/router.js';
import { renderNav } from './nav.js';

export async function renderHistoryList() {
  const { sessions } = await api.get<{ sessions: SessionRow[] }>('/history?limit=50');

  const items = sessions.length
    ? el(
        'ul',
        { class: 'stack stack--sm' },
        sessions.map((s) =>
          el('li', {}, [
            el('a', { class: 'card row row--between', href: `#/history/${s.id}` }, [
              el('div', {}, [
                el('div', { class: 'h3' }, [`Treino ${s.workout_code}`]),
                el('div', { class: 'muted', style: 'font-size: var(--text-sm)' }, [
                  formatDateTime(s.started_at),
                  ` · ${s.set_count} sets`,
                ]),
                s.notes
                  ? el(
                      'div',
                      {
                        class: 'dim',
                        style: 'font-size: var(--text-sm); margin-top: var(--space-1)',
                      },
                      [s.notes.slice(0, 80)],
                    )
                  : null,
              ]),
              el('span', { class: 'dim' }, ['›']),
            ]),
          ]),
        ),
      )
    : el('p', { class: 'dim' }, ['Nenhuma sessão ainda.']);

  mount(
    el('main', { class: 'view' }, [
      el('h1', { class: 'h1', style: 'margin-bottom: var(--space-5)' }, ['Histórico']),
      items,
      renderNav('history'),
    ]),
  );
}

export async function renderHistoryDetail(params: Record<string, string>) {
  const id = Number(params.id);
  const { session, sets } = await api.get<SessionDetail>(`/history/${id}`);

  const groups = new Map<string, typeof sets>();
  for (const s of sets) {
    const arr = groups.get(s.exercise_name) ?? [];
    arr.push(s);
    groups.set(s.exercise_name, arr);
  }

  const blocks = [...groups.entries()].map(([name, list]) =>
    el('section', { class: 'card', style: 'margin-bottom: var(--space-3)' }, [
      el('div', { class: 'h3', style: 'margin-bottom: var(--space-2)' }, [name]),
      el(
        'ul',
        { class: 'stack stack--sm' },
        list.map((s) =>
          el('li', { class: 'row row--between', style: 'font-variant-numeric: tabular-nums' }, [
            el('span', { class: 'muted' }, [`Série ${s.set_number}`]),
            el('span', {}, [`${s.weight_kg}kg × ${s.reps}`]),
          ]),
        ),
      ),
    ]),
  );

  mount(
    el(
      'main',
      { class: 'view' },
      [
        el('header', { class: 'session-head' }, [
          el('div', {}, [
            el('div', { class: 'field__label' }, [`Treino ${session.workout_code}`]),
            el('div', { style: 'font-size: var(--text-lg); font-weight: 600' }, [
              formatDateTimeFull(session.started_at),
            ]),
          ]),
          el(
            'button',
            {
              class: 'btn btn--ghost',
              type: 'button',
              onclick: () => navigate('/history'),
            },
            ['‹ Voltar'],
          ),
        ]),
        session.notes
          ? el('div', { class: 'card', style: 'margin-bottom: var(--space-4)' }, [
              el('div', { class: 'field__label', style: 'margin-bottom: var(--space-2)' }, [
                'Notas',
              ]),
              el('div', {}, [session.notes]),
            ])
          : null,
        ...blocks,
        renderNav('history'),
      ].filter(Boolean) as Node[],
    ),
  );
}
